import axios from "axios";

const endpoint_url = "/message/options/whatsappMessageTemplates";

const optionWhatsappMessageTemplate = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default optionWhatsappMessageTemplate;
